import { Color } from './color'

export class ColorUtils {
  static getContrastColor (colorString: string): string {
    if (!colorString) {
      return 'black'
    }
    let hexColor = colorString
    if (colorString.indexOf('rgb') >= 0) {
      hexColor = ColorUtils.convertRgbaToHex(colorString)
    }
    if (hexColor.indexOf('#') !== 0 || hexColor.length <= 6) {
      const colors = require('color-name') // eslint-disable-line @typescript-eslint/no-var-requires
      const colorParts = (colors[colorString] as string[])
      if (!colorParts) {
        return 'black'
      }
      hexColor = ColorUtils.getHexFromRgbParts(colorParts)
    }
    return ColorUtils.getContrastColorFromHex(hexColor)
  }

  static getContrastColorFromHex (hexcolor: string): string {
    hexcolor = hexcolor.replace('#', '')
    const r = parseInt(hexcolor.substr(0, 2), 16)
    const g = parseInt(hexcolor.substr(2, 2), 16)
    const b = parseInt(hexcolor.substr(4, 2), 16)
    const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000
    return (yiq >= 128) ? 'black' : 'white'
  }

  static convertRgbaToHex (rgbaColor: string): string {
    const parts = this.getRgbaParts(rgbaColor)
    return (parts && parts.length === 4)
      ? ColorUtils.getHexFromRgbParts([parts[1], parts[2], parts[3]])
      : ''
  }

  static getRgbaParts (rgbaColor: string): RegExpMatchArray | null {
    return rgbaColor.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i)
  }

  static getHexFromRgbParts (parts: string[]): string {
    return (parts && parts.length === 3)
      ? '#' +
      ('0' + parseInt(parts[0], 10).toString(16)).slice(-2) +
      ('0' + parseInt(parts[1], 10).toString(16)).slice(-2) +
      ('0' + parseInt(parts[2], 10).toString(16)).slice(-2)
      : ''
  }

  static getWithOpacity (color: string, opacity: string): string {
    const c = new Color(color)
    c.a = parseFloat(opacity)
    return c.toRgba()
  }
}
